import mutate from 'js-core/js/apollo/mutations/mutate';
import invalidateQuery from 'js-core/js/apollo/mutations/invalidateQuery';
import invalidateFragment from 'js-core/js/apollo/mutations/invalidateFragment';

import CreateSectionMutation from 'gql/mutations/Section/CreateSection.gql';
import UpdateSectionMutation from 'gql/mutations/Section/UpdateSection.gql';
import DeleteSectionMutation from 'gql/mutations/Section/DeleteSection.gql';

export default class{

    static create(input) {

        return mutate(CreateSectionMutation, { input }, store => {

            invalidateQuery(store, 'allSections');
            invalidateFragment(store, 'Parcel', input.parcelId);
        });
    }

    static update(input) {

        return mutate(UpdateSectionMutation, { input });
    }

    static delete(id) {

        return mutate(DeleteSectionMutation, { id }, store => {

            invalidateQuery(store, 'allSections');
        });
    }
}
